<template>
	<div class="ProgrammePrice">
		<span
			v-if="hasTuition && originalOffer"
			class="OriginalOffer"
		>
			{{ originalOffer }}/{{ durationPeriod }}
		</span>

		<span
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '2.938rem', height: '1rem' },
				},
				margins: {
					Small: '0 0.5rem 0 0',
				}
			}"
			class="Duration"
		>
			{{ durationLong }}
		</span>

		<span
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '6.688rem', height: '1rem' },
				}
			}"
			:class="['CurrentPrice', { 'noDuration': !(!!durationLong) }]"
		>
			<template v-if="hasTuition && tuition.amount > 0">
				<b>{{ price }}</b>/{{ durationPeriod }}
			</template>
			<template v-else-if="hasTuition">
				<b>Free</b>
			</template>
			<template v-else>
				<b>Tuition not available</b>
			</template>
		</span>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type ITuition from '@app/interfaces/dtos/ITuition';
import type { PropType } from 'vue';
import { FormatCurrencyService } from '@infrastructure/currency/FormatCurrencyService.server';

const props = defineProps({
	tuition: {
		type: Object as PropType<ITuition | null>,
		default: null,
	},
	duration: {
		type: String,
		default: '',
	},
	loading: {
		type: Boolean,
		default: false,
	},
});

const hasTuition = computed(() => !!props.tuition);

const price = computed(() => {
	if(props.tuition === null) return '';

	const amount = props.tuition.discountedAmount || props.tuition.amount;
	return FormatCurrencyService.format(amount, props.tuition.currency);
});

const originalOffer = computed(() =>

	props.tuition?.discountedAmount ? FormatCurrencyService.format(props.tuition.amount, props.tuition.currency) : ''
);
const durationLong = computed(() => props.duration || '');
const durationPeriod = computed(() => {
	const periodLower = props.tuition?.period?.toLowerCase();


	if (periodLower?.includes('year')) return 'yr';
	if (periodLower?.includes('month')) return 'period';
	if (periodLower?.includes('week')) return 'wk';
	if (periodLower?.includes('day')) return 'day';

	return props.tuition?.period;
});
</script>

<style scoped lang="scss">
	.ProgrammePrice {
		display: block;
		width: 100%;
		text-align: right;

		@include MarginAreas(0.5, 0, 0, 0);

		.OriginalOffer {
			display: block;
			text-decoration: line-through;
			color: $Grey-900;

			@include TextStyle(UiSmallRegular);
		}

		.Duration {
			color: $Grey-900;

			@include TextStyle(UiMediumRegular);
		}

		.CurrentPrice {
			color: $Grey-900;

			@include TextStyle(UiMediumRegular);

			b {
				@include TextStyle(UiLargeBold);
			}

			&:not(.noDuration) {
				&::before {
					content: '•';
					@include MarginAreas(0, 0.25);
				}
			}
		}
	}
</style>
